<template>
    <div>
      <base-header class="pb-6">
        <div class="row align-items-center py-4">
          <div class="col-md-6 mb-3 mb-md-0">
            <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb/>
            </nav>
          </div>
          <div class="col-md text-md-right">
            <div v-show="!tabContact">
              <base-button class="rounded-pill" tag="a" type="celcompink" href="/contactos/nueva-lista" v-show="permisos.create">
                Nueva Lista <i class="fas fa-plus-circle fa-lg text-pink"></i>
              </base-button>
            </div>
          </div>

        </div>
      </base-header>

      <div class="container-fluid mt--6">
        <div class="row">
          <div class="col">

            <div class="card">
              <div class="card-header mb-4">

                  <div v-show="tabContact" class="col mb-4">
                    <div class="row justify-content-between">
                      <div class="d-flex align-items-md-center col-md px-0 mb-2 mb-md-0 flex-column flex-md-row align-items-start">
                        <h4 class="mb-0">
                          Lista
                        </h4>

                        <base-input input-classes="form-control-flush form-control-sm text-celcomblue font-weight-600"
                                    v-model="contactGroup.name"
                                    class="m-0 ml-md-2"
                                    v-on:dblclick="onEditContactGroupName(contactGroup)"
                                    v-on:keyup.enter="onEditContactGroupName(contactGroup)"
                                    v-if="cambiarNombre==false">
                        </base-input>
                        <a href="#!" @click.prevent="onEditContactGroupName(contactGroup)" class="font-weight-600 text-sm p-md-2 p-1 mb-0 ml-md-2" v-show="!cambiarNombre">
                          <i class="fas fa-pen"></i>
                        </a>

                        <form role="form" v-show="cambiarNombre">
                          <div class="row ml-0 ml-md-2 justify-content-md-between flex-column flex-md-row">
                            <base-input input-classes="form-control-flush form-control-sm text-celcomblue font-weight-600"
                                        v-model="contactGroup.name"
                                        class="m-0"
                                        placeholder="Nombre"
                                        v-on:keyup.enter="guardarEdicionGroupName(contactGroup)">
                            </base-input>

                            <div class="d-flex">
                              <base-button type="celcompink"
                                          class="mr-0 mr-md-2"
                                          size="sm"
                                          @click="guardarEdicionGroupName(contactGroup)">
                                Guardar
                              </base-button>
                              <base-button outline
                                          type="celcompink"
                                          size="sm"
                                          @click="cambiarNombre = false">
                                Cerrar
                              </base-button>
                            </div>
                          </div>
                        </form>
                      </div>

                      <div class="col-md d-flex justify-content-end px-0">
                        <base-button class="rounded-pill px-3 d-flex" size="sm" type="celcomblue" @click.prevent="abrirAgregar(contactSingle)">
                          Agregar contacto
                          <div class="icon icon-xs icon-shape bg-default text-white rounded-circle ml-2">
                            <i class="fas fa-user-plus"></i>
                          </div>
                        </base-button>
                        <base-button class="rounded-pill px-3 d-flex" size="sm" type="celcomblue" @click.prevent="abrirAgregarMasivo(contactSingle)">
                          Importar lista
                          <div class="icon icon-xs icon-shape bg-default text-white rounded-circle ml-2">
                            <i class="fas fa-address-book"></i>
                          </div>
                        </base-button>
                      </div>
                    </div>

                </div>

                <div class="d-flex justify-content-md-end">
                  <base-input v-model="keySearch"
                              prepend-icon="fas fa-search"
                              placeholder="Buscar..."
                              class="mb-0">
                  </base-input>
                </div>

              </div>

              <div class="col">

                <div v-show="tabContact">
                  <base-button outline type="celcompink" class="btn-icon-only rounded-circle mb-3" @click.prevent="obtenerLista()">
                    <span class="btn-inner--icon"><i class="fas fa-angle-left"></i></span>
                  </base-button>
                </div>
              </div>

              <div class="col-12" v-show="!tabContact">
                <el-table class="table-responsive table-flush table-striped"
                        header-row-class-name="thead-light"
                        :data="queriedData">
                  <el-table-column label="Nombre"
                                   prop="name"
                                   min-width="200px"
                                   sortable>
                      <template v-slot="{row}">
                          <div class="media align-items-center">
                              <div class="media-body">
                                  <a href="#!" v-show="permisos.modify" @click.prevent="onShowList(row,true)" class="font-weight-600 mb-0 text-sm text-celcomblue">{{row.name}}</a>
                                  <span v-show="!permisos.modify" class="font-weight-600 mb-0 text-sm text-celcomblue">{{row.name}}</span>
                              </div>
                          </div>
                      </template>
                  </el-table-column>
                  <el-table-column label="Fecha Creación"
                                   prop="created"
                                   min-width="200px"
                                   sortable>
                      <template v-slot="{row}">
                                   {{ fechaFormato(row.created) }}
                      </template>
                  </el-table-column>

                  <el-table-column label="Contactos"
                                   min-width="150px"
                                   sortable>
                      <template v-slot="{row}">
                                   {{ (row.validos + row.invalidos)}}
                      </template>
                  </el-table-column>

                  <el-table-column label="Válidos"
                                   prop="validos"
                                   min-width="125px"
                                   sortable>
                      <template v-slot="{row}">
                                    {{ row.validos }}
                      </template>
                  </el-table-column>

                  <el-table-column label="Inválidos"
                                   prop="invalidos"
                                   min-width="125px"
                                   sortable>
                      <template v-slot="{row}">
                                    {{ row.invalidos }}
                      </template>
                  </el-table-column>

                  <el-table-column label="Estado"
                                   prop="active"
                                   min-width="150px"
                                   sortable>
                      <template v-slot="{row}">
                          <badge class="mr-4" :type="(row.active==true) ? 'success' : 'danger'">
                              <span class="status">{{ (row.active==true) ? "Activo" : "Inactivo" }}</span>
                          </badge>
                      </template>
                  </el-table-column>
                  <el-table-column label="Acción" min-width="150px">
                      <div slot-scope="{row}" class="table-actions">
                        <el-tooltip content="Editar Lista" placement="top">
                          <a href="#!" @click.prevent="onShowList(row,true)" class="table-action table-action-edit" data-toggle="tooltip" data-original-title="Editar Lista" v-show="permisos.modify">
                            <i class="fas fa-edit"></i>
                          </a>
                        </el-tooltip>
                        <el-tooltip content="Eliminar" placement="top">
                          <a href="#!" @click.prevent="onDeleteContactGroup(row)" class="table-action table-action-delete" data-toggle="tooltip"
                            data-original-title="Eliminar Lista" v-show="permisos.destroy">
                            <i class="fas fa-trash"></i>
                          </a>
                        </el-tooltip>
                      </div>
                    </el-table-column>
                </el-table>
              </div>

              <div class="col-12" v-show="tabContact">

                <el-table class="table-responsive table-flush"
                        header-row-class-name="thead-light"
                        :data="queriedData">

                  <el-table-column label="Código de área"
                                   prop="phoneCode"
                                   min-width="200px"
                                   sortable>
                  </el-table-column>

                  <el-table-column label="Teléfono"
                                   prop="phone"
                                   min-width="250px"
                                   sortable>
                  </el-table-column>


                  <el-table-column label="Estado"
                                   prop="status"
                                   min-width="150px">
                                   <template v-slot="{row}">
                                      <badge class="mr-4" :type="(row.status==true) ? 'success' : 'danger'">
                                          <span class="status">{{ (row.status==true) ? "Activo" : "Inactivo" }}</span>
                                      </badge>
                                  </template>
                  </el-table-column>

                  <el-table-column label="Acción" min-width="150px">
                      <div slot-scope="{row}" class="table-actions">
                        <el-tooltip content="Editar" placement="top">
                          <a href="#!" @click.prevent="onEditContact(row)" class="table-action table-action-edit" data-toggle="tooltip" data-original-title="Editar lista">
                            <i class="fas fa-edit"></i>
                          </a>
                        </el-tooltip>
                        <el-tooltip content="Eliminar" placement="top">
                          <a href="#!" @click.prevent="onDeleteContact(row)" class="table-action table-action-delete" data-toggle="tooltip"
                            data-original-title="Eliminar Lista">
                            <i class="fas fa-trash"></i>
                          </a>
                        </el-tooltip>
                      </div>
                  </el-table-column>
                </el-table>

              </div>

              <div
                slot="footer"
                class="col-12 mt-4 d-flex justify-content-around justify-content-md-between flex-wrap mb-4 align-items-center"
              >
                  <div class="">
                    <small class="card-category">
                      Mostrando {{ from + 1 }} de {{ to }}  -  {{ total }} entradas

                      <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                      </span>
                    </small>

                  </div>

                  <div class="d-flex align-items-center flex-sm-row flex-column mt-sm-3">

                    <el-select class="select-primary pagination-select mb-3 mb-sm-0 mr-3"
                                v-model="pagination.perPage"
                                placeholder="Per page" >
                      <el-option class="select-primary"
                                  v-for="item in pagination.perPageOptions"
                                  :key="item"
                                  :label="item"
                                  :value="item" >
                      </el-option>
                    </el-select>
                    <base-pagination
                      class="pagination-no-border mb-0"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      :total="total"
                    >
                    </base-pagination>

                  </div>

              </div>
            </div>

          </div>
        </div>

        <div class="row">

          <modal :show.sync="modals.formSingle"
                  modal-classes="modal-secondary text-default"
                  modal-content-classes="bg-gradient-secondary">
            <h6 slot="header" class="modal-title text-default">Editar número contacto</h6>
            <form role="form">
              <div class="row">
                <base-input
                            v-model="validForm.CodePhoneContact"
                            class="mb-3 col-md-6"
                            placeholder="Código"
                            disabled
                            prepend-icon="ni ni-world">
                </base-input>
                <base-input
                            v-model.number="contactSingle.phone"
                            type="number"
                            class="mb-3 col-md-6"
                            placeholder="Teléfono"
                            :error="(validForm.field.includes('PhoneContact')) ? 'Inválido, el teléfono debe contener 8 dígitos' : ''"
                            prepend-icon="ni ni-email-83">
                </base-input>
              </div>

              <div class="d-flex justify-content-between my-4">
                <base-button type="celcompink"
                              @click="guardarEdicion(contactSingle)">
                    Guardar
                </base-button>
                <base-button outline
                              type="celcompink"
                              @click="modals.formSingle = false">
                    Cerrar
                </base-button>
              </div>
            </form>

          </modal>

          <modal :show.sync="modals.formGroup"
                  modal-classes="modal-secondary text-default"
                  modal-content-classes="bg-gradient-secondary">
            <h6 slot="header" class="modal-title text-default">Editar nombre lista</h6>
            <form role="form">
              <base-input
                          v-model="contactGroup.name"
                          class="mb-3"
                          placeholder="Nombre"
                          prepend-icon="ni ni-badge">
              </base-input>

              <div class="d-flex justify-content-between my-4">
                <base-button type="celcompink"
                              @click="guardarEdicionGroup(contactGroup)">
                    Guardar
                </base-button>
                <base-button outline
                             type="celcompink"
                             @click="modals.formGroup = false">
                    Cerrar
                </base-button>
              </div>
            </form>

          </modal>

          <modal :show.sync="modals.formGroupName"
                  modal-classes="modal-secondary text-default"
                  modal-content-classes="bg-gradient-secondary">
            <h6 slot="header" class="modal-title text-default">Editar nombre lista</h6>
            <form role="form">
              <base-input
                          v-model="contactGroup.name"
                          class="mb-3"
                          placeholder="Nombre"
                          prepend-icon="ni ni-badge">
              </base-input>

              <div class="d-flex justify-content-between my-4">
                <base-button type="celcompink"
                              @click="guardarEdicionGroupName(contactGroup)">
                    Guardar
                </base-button>
                <base-button outline
                              type="celcompink"
                              @click="modals.formGroupName = false">
                    Cerrar
                </base-button>
              </div>
            </form>

          </modal>

          <modal :show.sync="modals.advertenciaSingle"
              gradient="danger"
              modal-classes="modal-danger modal-dialog-centered">
            <h6 slot="header" class="modal-title" id="modal-title-notification">Borrar contacto</h6>

            <div class="text-center">
                <i class="fas fa-exclamation-circle ni-3x mb-3"></i>
                <p class="mb-0">Estás a punto de eliminar este contacto.</p>
                <span>{{ validForm.CodePhoneContact }} {{ contactSingle.phone }}</span>
            </div>

            <template slot="footer">
                <base-button type="white text-danger"
                              @click="borrarContacto(contactSingle)">
                    Borrar
                </base-button>
                <base-button type="link"
                              class="ml-auto text-white"
                              @click="modals.advertenciaSingle = false">
                    Cerrar
                </base-button>
            </template>
          </modal>

          <modal :show.sync="modals.advertenciaGroup"
                gradient="danger"
                modal-classes="modal-danger modal-dialog-centered">
              <h6 slot="header" class="modal-title" id="modal-title-notification">Borrar lista</h6>

              <div class="text-center">
                  <i class="fas fa-exclamation-circle ni-3x mb-3"></i>
                  <p class="mb-0">Estás a punto de eliminar esta lista.</p>
                  <span>{{ contactGroup.name }}</span>
              </div>

              <template slot="footer">
                  <base-button type="white text-danger"
                               @click="borrarContactoGroup(contactGroup)">
                      Borrar
                  </base-button>
                  <base-button type="link"
                               class="ml-auto text-white"
                               @click="modals.advertenciaGroup = false">
                      Cerrar
                  </base-button>
              </template>
          </modal>

          <modal :show.sync="modals.agregarContacto"
                  modal-classes="modal-secondary text-default"
                  modal-content-classes="bg-gradient-secondary">
            <h6 slot="header" class="modal-title text-default">Agregar número contacto</h6>
            <form role="form">
              <div class="row">
                <base-input
                            v-model="validForm.CodePhoneContact"
                            class="mb-3 col-md-6"
                            placeholder="Código"
                            disabled
                            prepend-icon="ni ni-world">
                </base-input>
                <base-input
                            v-model.number="validForm.PhoneContact"
                            type="number"
                            class="mb-3 col-md-6"
                            placeholder="Teléfono"
                            :error="(validForm.field.includes('PhoneContact')) ? 'Inválido, el teléfono debe contener 8 dígitos' : ''"
                            prepend-icon="ni ni-email-83">
                </base-input>
              </div>

              <div class="d-flex justify-content-between my-4">
                <base-button type="celcompink"
                              @click="guardarNuevo(contactSingle)">
                    Guardar
                </base-button>
                <base-button outline
                              type="celcompink"
                              @click="modals.agregarContacto = false">
                    Cerrar
                </base-button>
              </div>
            </form>

          </modal>

          <modal :show.sync="modals.agregarMasivo"
                  modal-classes="modal-secondary text-default"
                  modal-content-classes="bg-gradient-secondary">
            <h6 slot="header" class="modal-title text-default">Agregar lista de contactos</h6>
            <form role="form">

              <dropzone-file-upload v-model="fileSingle">
              </dropzone-file-upload>

              <base-alert type="success" v-show="importadosBien">
                  <span class="alert-inner--icon"><i class="fas fa-thumbs-up mr-2"></i></span>
                  <span class="alert-inner--text">¡Se importaron tus contactos!</span>
              </base-alert>

              <div class="d-flex justify-content-between my-4">
                <base-button type="celcompink"
                              @click="modals.agregarMasivo = false">
                    Guardar
                </base-button>
                <base-button outline
                              type="celcompink"
                              @click="modals.agregarMasivo = false">
                    Cerrar
                </base-button>
              </div>
            </form>

          </modal>

        </div>

      </div>

  </div>
</template>
<script>
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui'
  import { BasePagination, Modal, Dialog } from '@/components';
  import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload';

  import moment from 'moment';
  import XLSX from 'xlsx';
  import swal from 'sweetalert2';
  import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin';
  import Fuse from 'fuse.js';

  import AES256 from 'aes-everywhere';
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Config from '@/config/config.js'
  import { getUser, setUser, encryptAES, horaAhora, search_data, onPermissionsUser,getUserSub } from '@/util/util.js';

  Vue.use(VueAxios, axios)
  Vue.use(Dialog)

  export default {
    mixins: [clientPaginationMixin],
    components: {
      DropzoneFileUpload,
      BasePagination,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Select.name]: Select,
      [Option.name]: Option,
      Modal,
      Dialog
    },
    data() {
      return {
        currentPage: 1,
        tableData: [],
        listaContactos: [],
        selectedRows: [],
        tabContact: false,
        cambiarNombre: false,
        importadosBien: false,
        listaNombre: "",
        contactGroup: {},
        contactSingle: {},
        modals: {
          formSingle: false,
          formGroup: false,
          formGroupName: false,
          advertenciaSingle: false,
          advertenciaGroup: false,
          agregarContacto: false,
          agregarMasivo: false
        },
        fileSingle: [],
        fuse: null,
        searchTable: '',
        currentContactGroup:"",
        result: [],
        validForm:{
          estado:false,
          field:"",
          listName:"",
          CodePhoneContact:getUser().customer.country.phoneCode,
          PhoneContact:"",
          listContact:"",
          dateProgramgContact:"",
          menssageContact:"",
          selectDraft:"",
          StepPreview:false,
          dateSend:"",
          sendingsms:"",
          contacts:[],
          childrenId:null,
          sendingTotal:0,
          sendingsmsId:null,
        },
        keySearch:"",
        permisos: {
          create: onPermissionsUser('contacts.xhtml', 'create'),
          modify: onPermissionsUser('contacts.xhtml', 'modify'),
          destroy: onPermissionsUser('contacts.xhtml', 'destroy'),
        }
      };
    },
    methods: {



     obtenerLista() {

      this.$loading.show()   //delay default is 300ms

      let self = this;
       let user = (getUserSub()!=null) ? getUserSub() :getUser();

      let js = {
        "time_expired":horaAhora(),
        "customer":encodeURIComponent(JSON.stringify(user.customer))
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.contact_available, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {
            console.log(response)

            if (response.data.response === "200") {
              console.log(response.data.data);

              self.tabContact = false;
              self.tableData = response.data.data;

              /*var options = {
                  shouldSort: true,
                  threshold: 0.6,
                  location: 0,
                  distance: 100,
                  maxPatternLength: 32,
                  minMatchCharLength: 1,
                  keys: [
                    "name",
                  ]
              };


              self.fuse = new Fuse(self.tableData, options);
              self.result = self.tableData*/


            } else {
              console.log("No se encontró lista");
              swal({
                title: 'No se encontró lista',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'error',
              })
            }

            self.$loading.hide()

        })
        .catch(function (error) {
            console.log("No se encontró lista",error);
            swal({
              title: 'No se encontró lista',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-danger',
              type: 'error',
            })
            self.$loading.hide();
        });

      },
      onShowList(lista,contact_status) {

        if(contact_status){

          this.$loading.show()

        }

        let self = this;
         let user = (getUserSub()!=null) ? getUserSub() :getUser();


        let js = {
          "time_expired":horaAhora(),
          "contact_group":encodeURIComponent(JSON.stringify(lista)),
          "contact_status":contact_status
        }

        var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

        Vue.axios.post(Config.url_service+Config.contact_available_contact, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        })

          .then(function (response) {
              console.log(response)

              if (response.data.response === "200") {
                console.log(response.data.data);
                self.tabContact = true;

                self.listaNombre = lista.name;
                self.tableData = response.data.data;

                self.contactGroup = lista;

                self.currentContactGroup = lista;


              } else {
                console.log("No se encontró lista");
                swal({
                  title: 'No se encontró lista',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger',
                  type: 'error',
                })
              }
          if(contact_status){
              self.$loading.hide()
          }

          })
          .catch(function (error) {
              console.log("No se encontró lista",error);
              swal({
                title: 'No se encontró lista',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'error',
              })
              if(contact_status){
                self.$loading.hide()
              }
          });

      },
      onEditContactGroup(row) {

        let self = this;
        let modals = modals;

        self.contactGroup = row;
        self.modals.formGroup = true;

      },
      onEditContact(row) {

        let self = this;
        let modals = modals;

        self.contactSingle = row;
        self.modals.formSingle = true;

      },
      onEditContactGroupName(row) {

        let self = this;
        // let modals = modals;

        self.contactGroup = row;
        self.cambiarNombre = true;
        // self.modals.formGroupName = true;

      },
      guardarEdicionGroup(contactGroup) {

        this.$loading.show()

        let self = this;
         let user = (getUserSub()!=null) ? getUserSub() :getUser();

        let js = {
          "time_expired":horaAhora(),
          "contact_group":encodeURIComponent(JSON.stringify(this.contactGroup)),
          "customer":encodeURIComponent(JSON.stringify(user.customer)),
        }

        var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

        Vue.axios.post(Config.url_service+Config.contact_edit_contact_group, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        })
          .then(function (response) {
              console.log(response)

              if (response.data.response === "200") {
                console.log(response.data.data);

                self.tableData = response.data.data;
                self.modals.formGroup = false;

              } else {
                console.log("No se pudo editar nombre lista");
                swal({
                  title: 'No se pudo editar nombre lista',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger',
                  type: 'error',
                })
              }

              self.$loading.hide()

          })
          .catch(function (error) {
              console.log("No se pudo editar nombre lista",error);
              swal({
                title: 'No se pudo editar nombre lista',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'error',
              })
              self.$loading.hide();
          });

      },
      guardarEdicion(contactSingle) {

        this.$loading.show()

        let self = this;
         let user = (getUserSub()!=null) ? getUserSub() :getUser();

        let js = {
          "time_expired":horaAhora(),
          "contact_group":encodeURIComponent(JSON.stringify(this.contactGroup)),
          "contact":encodeURIComponent(JSON.stringify(this.contactSingle)),
          "customer":encodeURIComponent(JSON.stringify(user.customer)),
        }

        if (self.contactSingle.phone == "") {
          self.validForm.field+=",PhoneContact"; self.validForm.estado=true;

          self.$loading.hide()

          return false;

        } else if ( (user.customer.country.name == "Colombia" && self.contactSingle.phone.toString().length !== 9) || (user.customer.country.name == "Chile" && self.contactSingle.phone.toString().length !== 8) ) {

          self.validForm.field+=",PhoneContact"; self.validForm.estado=true;

          self.$loading.hide()

          return false;

        } else {

          var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

          Vue.axios.post(Config.url_service+Config.contact_edit_contact, body, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          })
            .then(function (response) {
                console.log(response)

                if (response.data.response === "200") {
                  console.log(response.data.data);

                  self.tableData = response.data.data;
                  self.modals.formSingle = false;

                  swal({
                    title: 'Contacto editado con éxito',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success',
                    type: 'success',
                  })

                } else {
                  console.log("No se pudo editar contacto");
                  swal({
                    title: 'No se pudo editar contacto',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-danger',
                    type: 'error',
                  })
                }

                self.$loading.hide()

            })
            .catch(function (error) {
                console.log("No se pudo editar contacto",error);
                swal({
                  title: 'No se pudo editar contacto',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger',
                  type: 'error',
                })
                self.$loading.hide();
            });

        }

      },
      guardarEdicionGroupName(contactGroup) {

        this.$loading.show()

        let self = this;
         let user = (getUserSub()!=null) ? getUserSub() :getUser();

        let js = {
          "time_expired":horaAhora(),
          "contact_group":encodeURIComponent(JSON.stringify(this.contactGroup)),
          "customer":encodeURIComponent(JSON.stringify(user.customer)),
        }

        var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

        Vue.axios.post(Config.url_service+Config.contact_edit_contact_group, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        })
          .then(function (response) {

              if (response.data.response === "200") {

                self.cambiarNombre = false;

              } else {
                console.log("No se pudo editar nombre lista");
                swal({
                  title: 'No se pudo editar nombre lista',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger',
                  type: 'error',
                })
              }

              self.$loading.hide()

          })
          .catch(function (error) {
              console.log("No se pudo editar nombre lista",error);
              swal({
                title: 'No se pudo editar nombre lista',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'error',
              })
              self.$loading.hide();
          });

      },
      onDeleteContact(row) {

        let self = this;
        let modals = modals;

        self.contactSingle = row;
        self.modals.advertenciaSingle = true;

      },
      onDeleteContactGroup(row) {

        let self = this;
        let modals = modals;

        self.contactGroup = row;
        self.modals.advertenciaGroup = true;

      },
      borrarContacto(contactSingle) {

        this.$loading.show()

        let self = this;
         let user = (getUserSub()!=null) ? getUserSub() :getUser();

        let js = {
          "time_expired":horaAhora(),
          "contact_group":encodeURIComponent(JSON.stringify(this.contactGroup)),
          "contact":encodeURIComponent(JSON.stringify(this.contactSingle)),
        }

        console.log(js)

        var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

        Vue.axios.post(Config.url_service+Config.contact_delete_contact, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        })
          .then(function (response) {
              console.log(response)

              if (response.data.response === "200") {
                console.log(response.data.data);

                self.tableData = response.data.data;
                self.modals.advertenciaSingle = false;

              } else {
                console.log("No se pudo borrar contacto");
                swal({
                  title: 'No se pudo borrar contacto',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger',
                  type: 'error',
                })
              }

              self.$loading.hide()

          })
          .catch(function (error) {
              console.log("No se pudo borrar contacto",error);
              swal({
                title: 'No se pudo borrar contacto',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'error',
              })
              self.$loading.hide();
          });

          self.$loading.hide()

      },
      borrarContactoGroup(contactGroup) {


        this.modals.advertenciaGroup = false;

        this.$loading.show()

        let self = this;
         let user = (getUserSub()!=null) ? getUserSub() :getUser();

        let js = {
          "time_expired":horaAhora(),
          "contact_group":encodeURIComponent(JSON.stringify(this.contactGroup)),
          "customer":encodeURIComponent(JSON.stringify(user.customer)),
        }

        var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

        Vue.axios.post(Config.url_service+Config.contact_delete_contact_group, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        })
          .then(function (response) {
              console.log(response)

              if (response.data.response === "200") {
                console.log(response.data.data);

                self.tableData = response.data.data;

              } else {
                console.log("No se pudo borrar lista");
                swal({
                  title: 'No se pudo borrar lista',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger',
                  type: 'error',
                })
              }

              self.$loading.hide()

          })

          .catch(function (error) {
              console.log("No se pudo borrar lista",error);
              swal({
                title: 'No se pudo borrar lista',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'error',
              })
              self.$loading.hide();
          });

      },
      abrirAgregar(contactSingle) {

        let self = this;
        let modals = modals;

        self.validForm.field="";

        self.modals.agregarContacto = true;

      },
      abrirAgregarMasivo(contactSingle) {

        let self = this;
        let modals = modals;

        self.modals.agregarMasivo = true;

      },
      guardarNuevo(contactSingle) {

        this.$loading.show()

        let self = this;
         let user = (getUserSub()!=null) ? getUserSub() :getUser();

        let nuevoContacto = {
          "phoneCode": this.validForm.CodePhoneContact,
          "phone": this.validForm.PhoneContact,
          //"contactGroup": this.contactGroup,
          "field": "usuario1|21|23500||||||||||",
          "status": true,
          "selected": false
        };

        let js = {
          "time_expired":horaAhora(),
          "contact_group":encodeURIComponent(JSON.stringify(this.contactGroup)),
          "contact":encodeURIComponent(JSON.stringify(nuevoContacto)),
          "customer":encodeURIComponent(JSON.stringify(user.customer)),
        }

        if (self.validForm.PhoneContact == "") {
          self.validForm.field+=",PhoneContact"; self.validForm.estado=true;

          self.$loading.hide()

          return false;

        } else if ( (user.customer.country.name == "Colombia" && self.validForm.PhoneContact.toString().length !== 9) || (user.customer.country.name == "Chile" && self.validForm.PhoneContact.toString().length !== 8) ) {

          self.validForm.field+=",PhoneContact"; self.validForm.estado=true;

          self.$loading.hide()

          return false;

        } else {

          var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

          Vue.axios.post(Config.url_service+Config.contact_add_contact, body, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          })
            .then(function (response) {
                console.log(response)

                if (response.data.response === "200") {
                  console.log(response.data.data);

                  self.tableData = response.data.data;
                  self.modals.agregarContacto = false;

                  swal({
                    title: '¡Contacto agregado!',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success',
                    type: 'success',
                  })

                } else {
                  console.log("No se pudo crear contacto");
                  swal({
                    title: 'No se pudo crear contacto',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-danger',
                    type: 'error',
                  })
                }

                self.$loading.hide()

            })

            .catch(function (error) {
                console.log("No se pudo crear contacto",error);
                swal({
                  title: 'No se pudo crear contacto',
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger',
                  type: 'error',
                })
                self.$loading.hide();
            });

          self.$loading.hide()

        }

      },
      fechaFormato(unixTimestamp) {
        return moment(unixTimestamp).format('YYYY-MM-DD HH:mm:ss');
      },

      async createListContact(contacts,interation,current,total_contacts){


        var self = this;
         //LOGICA QUE CREA ARRAY DE CONTACTOS
        let nuevoContacto = [];
        var c=0;
         contacts.forEach(function(key){

           var phone = "";
           var phoneCode = "";
           var field = "";
           // if(c > 0){
              for(var j = 0 ; j < key.length ; j++){

                    if(j == 0){
                        phoneCode=key[j];
                    }
                    if(j == 1){
                        phone=key[j];
                    }
                    if(j > 1){
                        field+=key[j]+"|";
                    }
                }

                //VALIDA QUE SEA SOLO NUMERO
               if (/^([0-9])*$/.test(phone) && /^([0-9])*$/.test(phoneCode)){
                  nuevoContacto.push({
                      "phoneCode": phoneCode,
                      "phone": phone,
                      //"contactGroup": self.contactGroup,
                      "field": field,
                      "status": true,
                      "selected": false
                });
               }


            //}
            c++;

        })

         let user = (getUserSub()!=null) ? getUserSub() :getUser();

        this.$loading.show()

        let js = {
          "time_expired":horaAhora(),
          "contact_group":encodeURIComponent(JSON.stringify(self.contactGroup)),
          "contact":encodeURIComponent(JSON.stringify(nuevoContacto)),
          "customer":encodeURIComponent(JSON.stringify(user.customer)),
        }

        var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

        await Vue.axios.post(Config.url_service+Config.contact_add_contacts, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        })
          .then(function (response) {

              console.log(response)

              if (response.data.response === "200") {

                  console.log("contactos importados : ",response.data.data);


                console.log("slice nueva iteration  : ",interation[current]);


                //SI ESTA INDEFINIDAD LA LISTA ES MENOR A 4000 Y NO HACE RECURSIVIDAD
                if(interation.length >= 1){

                //VALIDA QUE TODOS LOS CONTACTOS SE IMPORTARAN Y TERMINA RECURSIVIDAD
                if(interation[current].i >= (total_contacts.length+4000)){

                  self.importadosBien = true;
                  self.listaTerminada = true;

                   swal({
                      title: '¡Contactos agregados!',
                      buttonsStyling: false,
                      confirmButtonClass: 'btn btn-success',
                      type: 'success',
                    })

                  self.createdContact = response.data.data;

                  self.$loading.hide();

                }else{
                    //FUNCION RECURSIVA DE IMPORTAR CONTACTOS
                   self.createListContact(total_contacts.slice(interation[current].init,interation[current].i),interation,(current+1),total_contacts);

                }

                }else{


                  swal({
                      title: '¡Contactos agregados!',
                      buttonsStyling: false,
                      confirmButtonClass: 'btn btn-success',
                      type: 'success',
                    })

                  self.importadosBien = true;
                  self.listaTerminada = true;

                  self.nuevaListaContact = response.data.data;

                  self.$loading.hide();

                }

              self.modals.agregarMasivo = false;


              } else {
                console.log("No se pudo crear contacto");
                swal({
                  title: "Error no se pudo crear contacto",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger btn-fill',
                  type: 'error'
                })
              }

              self.$loading.hide();


          })

      },
    },
    mounted() {





     let listcontact_init = JSON.parse(localStorage.getItem('listcontact_init'));

      if(listcontact_init!==null && typeof listcontact_init.contactGroupId!=="undefined"){
          this.$loading.show();
          this.onShowList(listcontact_init,false);
          localStorage.removeItem('listcontact_init')
          this.$loading.hide();
      }else{

          this.obtenerLista();


      }


      let self = this;

      if(!onPermissionsUser('contacts.xhtml', 'view')) {
        swal({
          title: 'No tienes los permisos para acceder a esta página.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-danger',
          type: 'error',
          }).then(function() {
            window.location.href="/dashboard";
        })

      }

    },
    watch: {

      'keySearch'(newVal){
          if(newVal.toString().length>3){
            this.searchedData = search_data(newVal, this.tableData);
          }else{
            this.searchedData = this.tableData;
          }
      },
      'currentContactGroup'(newVal){
          this.onShowList(newVal,false);
      },

      /**
     * IMPORTAR LISTA DESDE EXCEL
     */
     'fileSingle'(e){

       var self = this;


        this.$loading.show();

        var files = e, f = files[0];
        var reader = new FileReader();
        reader.onload = function(e) {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, {type: 'array'});

          var first_worksheet = workbook.Sheets[workbook.SheetNames[0]];
          var data = XLSX.utils.sheet_to_json(first_worksheet, {header:1});

          console.log("datos importados : ",data);

          let header = "";

          //crea header
          if(data.length > 0){
            data[0].forEach(function(key){
              if(key!="codigo" && key!="numero"){
                  header+=key+"|";
              }
            });
          }
       if( (self.contadorContactImportados+data.length) > 40000 ){
            swal({
                  title: "Error limite de contactos excedidos",
                  buttonsStyling: false,
                  confirmButtonClass: 'btn btn-danger btn-fill'
                })

                return false;
        }

        console.log("datos importados header : ",header);


        //PERAPARA CANTIDAD DE INTERACCIONES
           var i=4000;var init =1;var interation = [];
           data.forEach(function(key){
             if ( i % 4000 == 0 ) {

              console.log("slice  : "+init+" "+i);

              interation.push({'init':(init+1),'i':i})

                init = i;
             }
             i++;
           })
            interation.push({'init':data.length,'i':(data.length+4000)})


          self.createListContact(data.slice(1,4000),interation,1,data);


        };
        reader.readAsArrayBuffer(f);

     }

    },
    computed: {



    }
  }
</script>

<style>
.modal-secondary .close > span:not(.sr-only) {
  color: #172b4d;
}
.busy-mask {
  z-index: 1051;
}
.fondo-circulo {
  width: 30px;
  height: 30px;
  margin-left: .5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
